(function () {
    'use strict';
	angular.module(modules.homeModule).component('handbookDailyStatistics', {
        templateUrl: 'app/components/statistics/daily-statistics/daily-statistics.html',
        controller: controller,
        controllerAs: 'vm',
        bindings: {
        }
    });

	controller.$inject = ['$http', '$scope'];
	function controller($http, $scope) {
		var vm = this;
		vm.docUsageTodaysSetting = [];
		
		$scope.$on("tabStatisticsActived", function (evt, data) {
			if (data == 'dailyStatistics' && (!vm.docUsageTodaysSetting || vm.docUsageTodaysSetting.length == 0)) {
				initialize();
			}
		});

		function initialize() {
			buildGridSetting();
			getDailyStatistics();
		}

		function getDailyStatistics() {
			var promise = $http.get('/api/Documents/GetDailyStatisticsOverView', {});
			promise.success(function (data, status, headers, config) {
				var result = data;
				vm.objHandbookStatistics = result.objHandbookStatistics;
				vm.arrDailyStatistics = result.arrDailyStatistics;
				vm.docUsageTodays = result.docUsageTodays;

				getHighCharts(vm.arrDailyStatistics);
			});
		}

		function buildGridSetting() {
			vm.docUsageTodaysSetting = [
				{ id: 'name', name: resources.L.Statistics.mostReadToday, width: 57, coldefault: true , isObject: false },
				{ id: 'id', name: resources.L.Statistics.documentId, width: 26, coldefault: true, isObject: false },
				{ id: 'countValue', name: resources.L.Statistics.quantity, width: 18, coldefault: true, isObject: false, customCss: 'text-right' }
			];
		}

		function getHighCharts(data) {
			if (!data || !data.length)
				return;
			var categories = data.map(x => x.accessDateDisplay);
			var documents = data.map(x => x.docAccessCount);
			var users = data.map(x => x.userAccessCount);

			var aa = document.getElementById('daily-charts-id');

			var chart = Highcharts.chart('daily-charts-id', {
				chart: {
					zoomType: 'xy',			
				},
				title: {
					text: resources.L.Statistics.dailyUseDoc
				},
				subtitle: {
					text: ''
				}, 
				xAxis: [{
					categories: categories,
					crosshair: true
				}],
				yAxis: [{ // Primary yAxis
					allowDecimals: false,
					labels: {
						format: '{value}',
						style: {
							color: Highcharts.getOptions().colors[1]
						}
					},
					title: {
						text: resources.L.Statistics.users,
						style: {
							color: Highcharts.getOptions().colors[1]
						}
					}
				}, { // Secondary yAxis
					title: {
						text: resources.L.Common.documents,
						style: {
							color: Highcharts.getOptions().colors[0]
						}
					},
					labels: {
						format: '{value}',
						style: {
							color: Highcharts.getOptions().colors[0]
						}
					},
					opposite: true
				}],
				tooltip: {
					shared: true
				},
				legend: {
					layout: 'vertical',
					align: 'left',
					x: 50,
					verticalAlign: 'top',
					y: -10,
					floating: true,
					backgroundColor:
						Highcharts.defaultOptions.legend.backgroundColor || // theme
						'rgba(255,255,255,0.25)'
				},
				series: [{
					name: resources.L.Common.documents,
					type: 'column',
					yAxis: 1,
					data: documents,
					tooltip: {
						valueSuffix: ''
					}

				}, {
					name: resources.L.Statistics.users,
					type: 'spline',
					data: users,
					tooltip: {
						valueSuffix: ''
					}
				}]
			});		
		}
    }
})();